module.exports = __webpack_public_path__ + "icon.png?68de82495d01bf5d156b2ad63465fa42";